import React from "react";
import { Link } from "react-router-dom";
import Banner from "../../Constant/Banner/Banner";
import HorizontalLine from "../../Constant/HorizontalLine";
const Careers = () => {
  return (
    <>
      <Banner imagePath="careerBanner.png" BannerText="Careers" />
      <div className="container">
        <section className="pb-3">
          <div className="row mt-4" style={{ paddingTop: "2rem" }}>
            <div
              className="col-md-6"
              data-aos="fade-right"
              data-aos-offset="300"
              data-aos-easing="ease-in-sine"
            >
              <div className="blur-shadow-image mx-3 mb-5">
                <h1 className="text-primary mb-0">Join our team</h1>
                <br />
                <p className=" mb-md-5 mb-4">
                  At Omnia Steels, you're not just joining a company — you're
                  becoming part of a team of seasoned professionals who are
                  passionate about excellence. Our strength lies in the deep
                  industry experience and dedication of our people. We believe
                  in fostering a collaborative environment where your skills are
                  valued, your growth is supported, and your contributions make
                  a real impact. If you're driven, skilled, and ready to be part
                  of a company that values both precision and people, Omnia
                  Steels is the place for you.
                </p>
              </div>
            </div>
            <div
              className="col-md-6 mb-md-0 mb-4 px-md-6"
              data-aos="fade-left"
              data-aos-offset="300"
              data-aos-easing="ease-in-sine"
            >
              <img
                src="./images/Careers/careers.jpg"
                alt="img-blur-shadow"
                className="img-fluid  border-radius-lg max-height-600"
              />
            </div>
          </div>
        </section>
        <HorizontalLine />

        <div className="py-4">
          <div className="row">
            <div className="col-lg-7 mx-auto d-flex justify-content-center flex-column">
              <h1
                className="text-center text-primary"
                data-aos="fade-in"
                data-aos-offset="300"
                data-aos-easing="ease-in-sine"
              >
                Apply Now
              </h1>
              <form
                role="form"
                id="contact-form"
                method="post"
                autoComplete="off"
              >
                <div
                  className="card-body"
                  data-aos="zoom-in"
                  data-aos-offset="400"
                  data-aos-easing="ease-in-sine"
                >
                  <div className="row">
                    <div className="col-md-6">
                      <label>First Name</label>
                      <div className="input-group mb-4">
                        <input
                          className="form-control"
                          placeholder=""
                          aria-label="First Name..."
                          type="text"
                        />
                      </div>
                    </div>
                    <div className="col-md-6 ps-2">
                      <label>Last Name</label>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder=""
                          aria-label="Last Name..."
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mb-4">
                    <label>Email Address</label>
                    <div className="input-group">
                      <input
                        type="email"
                        className="form-control"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div className="mb-4">
                    <label>Mobile Number</label>
                    <div className="input-group">
                      <input
                        type="tel"
                        pattern="[0-9]{10}"
                        className="form-control"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div className="mb-4">
                    <label>Upload Resume</label>
                    <div className="input-group">
                      <input
                        type="File"
                        className="form-control file-upload-button"
                        name="Upload Resume"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <button
                        type="submit"
                        className="btn bg-gradient-dark w-100"
                      >
                        Send Message
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Careers;
